import { getWidthToOffset } from './get-width-to-offset';

/**
 * Move the slides to go to the beginning of the current slide (to not stop in the middle of a slide)
 */
export const moveSlidesToFinalOffset = ({
	loop,
	currentSlideIndex,
	x,
	dragOffset,
	widths,
	reversedWidths,
	items,
	bounds,
}) => {
	if (loop) {
		if (x > 0) {
			// Get offset of current slide
			dragOffset.current = getWidthToOffset(widths, currentSlideIndex);
		} else {
			// Use reversedWidths as if x is below 0, the positions of the slides are reversed
			// => (slide `-1` is slide `items.length`; slide `-2` is slide `items.length - 1`; etc...)
			dragOffset.current = getWidthToOffset(
				reversedWidths,
				Math.abs(currentSlideIndex - items.length),
				-1
			);
		}
	} else {
		// Not in loop mode => don't go above the bounds limit
		if (x === bounds || currentSlideIndex === items.length - 1) {
			dragOffset.current = bounds;
		} else {
			// Get offset of current slide
			dragOffset.current = getWidthToOffset(widths, currentSlideIndex);
		}
	}
};
